function isSalesCenterSubDomain() {
  return window.location.host.startsWith('sales.')
}

export default isSalesCenterSubDomain
